import { useQuery } from "@tanstack/react-query";
import { api } from "@/lib/api";
import { BrandHeader } from "@/components/BrandHeader";

export default function Landing() {
  const ping = useQuery({
    queryKey: ["ping"],
    queryFn: async () => (await api.get<{ pong: boolean; at: string }>("/ping")).data,
  });

  return (
    <>
      <BrandHeader />
      <main className="mx-auto flex min-h-[calc(100vh-80px)] max-w-3xl flex-col items-center justify-center p-6">
      <div className="card w-full p-8">
        <h1 className="text-3xl font-bold text-brand">Online Test Assessment</h1>
        <p className="mt-2 text-brand-ink/70">
          Proctored online examination platform. Open a specific quiz via its shared link.
        </p>

        <div className="mt-6 rounded-xl bg-brand-light p-4 text-sm">
          <div className="font-semibold">API health</div>
          {ping.isLoading && <div>Checking…</div>}
          {ping.isError && <div className="text-brand">API unreachable</div>}
          {ping.data && <div>OK — pinged at {new Date(ping.data.at).toLocaleTimeString()}</div>}
        </div>

        <div className="mt-6 flex gap-3">
          <a href="/quiz/demo" className="btn-primary">Open demo quiz</a>
        </div>
      </div>
      </main>
    </>
  );
}
